export const createUserTrKey="@TRANSACTION/create_user";
export const updateManifestIdTrKey="@TRANSACTION/update_manifest_id";
export const redraftManifestTrKey="@TRANSACTION/redraft_manifest";
export const updateUserProfileTrKey = "TRANSACTION/updateUserProfileTrKey";
export const changePasswordTrKey = "TRANSACTION/changePasswordTrKey";
export const updateUserTrKey="@TRANSACTION/updateUserTrKey";
